/**
 * 작성자 : 한영광
 * 날짜 : 2023.12.12
 * 기능 : WebSDK 클래스
 */
import axios from 'axios';
import { apiDelete, apiGet, apiPost } from '../services/_common';
import * as speaker from './speaker';
import { toast } from 'react-toastify';

interface Speaker {
  index: number;
  ip: string;
  port: string;
  id: string;
  pwd: string;
}

export class WebSDKspeaker {
  index: number;
  status: number; // 0: 연결중, 1: 방송가능, 2: 방송중, 3: 방송불가
  flow: number;
  setOpenModal: any;
  data: Speaker;
  stateChangeListener: any;
  pluginOBJ: any;
  divPlugin: string;

  constructor({ setOpenModal, index, stateChangeListener, data, divPlugin }: { setOpenModal?: any; index?: number; stateChangeListener?: any; data?: any; divPlugin?: string }) {
    this.index = index || 0;
    this.status = 0;
    this.flow = 0;
    this.setOpenModal = setOpenModal;
    this.data = data;
    this.stateChangeListener = stateChangeListener;
    this.divPlugin = divPlugin || 'divPlugin';
    // this.init();
  }

  getIndex() {
    return this.index;
  }

  getStatus() {
    return this.status;
  }
  setStatus(status: number) {
    if (this.stateChangeListener) {
      this.stateChangeListener({ index: this.index, status });
    }
    this.status = status;
  }

  getFlow() {
    return this.flow;
  }
  setFlow(flow: number) {
    this.flow = flow;
    this.next();
  }

  next() {
    if (this.flow === 1) {
      this.login();
    }
  }

  getData() {
    return this.data;
  }

  /**
   * 작성자 : 한영광
   * 작성일자 : 2024.01.19
   * 작성내용 : 기존 WebSDK는 여러 장비에 동시에 연결한 경우 가장 최근 장비의 데이터만 유지되어 이전에 연결한 장비의 제어가 안되는 문제가 발생함
   *           따라서 WebSDK 플러그인에 연결시 해당 연결을 객체화 하여 여러 장비의 연결을 한 경우에도 각각 제어할 수 있도록 작업함
   */
  setPluginOBJ(obj: any) {
    this.pluginOBJ = obj;
  }

  getPluginOBJ() {
    return this.pluginOBJ;
  }

  async init() {
    // await this.beforeInitStop();
    await speaker.init(
      this.setOpenModal,
      // (e: any) => this.setFlow(e),
      (e: any) => this.setStatus(e),
      (e: any) => this.setPluginOBJ(e),
      this.divPlugin
    );
  }

  async login() {
    const res = await speaker.login(this.data.ip, this.data.port, this.data.id, this.data.pwd);
    if (res === 1) {
      const res2 = await this.connChk();
      return res2;
    }
    this.setStatus(res);
    return res;
  }

  logout() {
    speaker.logout(`${this.data.ip}_${this.data.port}`);
  }

  async connChk() {
    try {
      await this.reqConnCheck(this.data);
      this.setStatus(1);
      return 1;
    } catch {
      this.setStatus(3);
      return 3;
    }
  }

  async startRelay(sessionId: string, backendUrl: string) {
    return speaker
      .clickStartVoiceTalkRelay(`${this.data.ip}_${this.data.port}`, this.pluginOBJ, backendUrl, sessionId)
      .then(async (r: number) => {
        if (r === 4) {
          await axios
            .get(`http://localhost:8582/plugin/restart`)
            .then(() => {
              toast.warn('CCTV 플러그인을 재시작합니다.');
              setTimeout(() => window.location.reload(), 3000);
            })
            .catch(() => {
              this.setOpenModal((prev: any) => ({
                ...prev,
                data: 'pluginRestart',
                status: true,
                type: 'websdk',
              }));
            });
          return 3;
        }
        return r;
      })
      .catch((e: any) => e);
  }

  async stopPluginOnly() {
    const res = await speaker.clickStopVoiceTalk(`${this.data.ip}_${this.data.port}`, this.status, this.pluginOBJ);
    this.setStatus(res);
    return res;
  }

  async start() {
    await speaker
      .clickStartVoiceTalk(`${this.data.ip}_${this.data.port}`, this.pluginOBJ)
      .then(async (r) => {
        if (r === 4) {
          await axios
            .get(`http://localhost:8582/plugin/restart`)
            .then((res) => {
              toast.warn('CCTV 플러그인을 재시작합니다.');
              setTimeout(() => window.location.reload(), 3000);
            })
            .catch((e) => {
              this.setOpenModal((prev: any) => ({
                ...prev,
                data: 'pluginRestart',
                status: true,
                type: 'websdk',
              }));
            });
          this.setStatus(3);
          return 3;
        }
        this.setStatus(r);
        return r;
      })
      .catch((e) => {
        this.setStatus(e);
        return e;
      });
  }

  async stop() {
    await this.reqCloseAPI();
    const res2 = await speaker.clickStopVoiceTalk(`${this.data.ip}_${this.data.port}`, this.status, this.pluginOBJ);
    this.setStatus(res2);
    return res2;
  }

  async beforeInitStop() {
    await this.reqCloseAPI();
    await speaker.clickStopVoiceTalk(`${this.data.ip}_${this.data.port}`, this.status, this.pluginOBJ);
  }

  async reqCloseAPI() {
    await apiGet({ path: '/bs/isapi', req: { url: `http://${this.data.ip}:${this.data.port}/ISAPI/System/TwoWayAudio/channels/1/close`, method: 'PUT', id: this.data.id, pwd: this.data.pwd } });
  }

  /* eslint-disable class-methods-use-this */
  async reqGetStorageSizeAPI(param: { ip: string; port: string; id: string; pwd: string }) {
    const res = await apiGet({
      path: '/bs/isapi',
      req: {
        url: `http://${param.ip}:${param.port}/ISAPI/AccessControl/EventCardLinkageCfg/CustomAudio/GetCustomAudioStorageInfo?format=json`,
        method: 'GET',
        id: param.id,
        pwd: param.pwd,
      },
    });
    return res?.data.data;
  }

  async reqGetAudioFileAPI(hCd: string, sCd: string, param: { ip: string; port: string; id: string; pwd: string }) {
    const res = await apiGet({ path: '/bs/isapi/audiofile', req: { hCd, sCd, id: param.id, pwd: param.pwd, ip: param.ip, port: param.port } });
    return res.data.data;
  }

  async reqPostAudioFileAPI(param: { ip: string; port: string; id: string; pwd: string; bsfCd: string; bsfFurl: string }) {
    const res = await apiPost({ path: '/bs/isapi/audiofile', req: { bsfCd: param.bsfCd, bsfFurl: param.bsfFurl, id: param.id, pwd: param.pwd, ip: param.ip, port: param.port } });
    if (res.status !== 201) {
      throw new Error(res);
    }
    return res;
  }

  async reqDeleteAudioFileAPI(param: { ip: string; port: string; id: string; pwd: string; customAudioIDList: number[] }) {
    const res = await apiDelete({
      path: '/bs/isapi/audiofile',
      contentType: 'application/json',
      req: { customAudioIDList: param.customAudioIDList, id: param.id, pwd: param.pwd, ip: param.ip, port: param.port },
    });
    if (res.status !== 200) {
      throw new Error(res);
    }
    return res;
  }

  async reqGetBroadcastAPI(param: { hCd: string; sCd: string; bsCd: string; ip: string; port: string; id: string; pwd: string }) {
    const res = await apiGet({ path: '/bs/isapi/broadcast', req: param });
    return res.data.data;
  }

  async reqPostBroadcastAPI(param: { hCd: string; sCd: string; bsCd: string; ip: string; port: string; id: string; pwd: string; broadcastPlanSchemeList: any }) {
    const res = await apiPost({
      path: '/bs/isapi/broadcast',
      req: param,
      contentType: 'application/json',
    });
    if (res.status !== 201) {
      throw new Error(res);
    }
    return res;
  }

  // async reqPostInitAPI(req: { hCd: string; sCd: string; id: string; pwd: string; ip: string; port: string }) {
  //   const res = await apiPost({ path: '/bs/isapi/init', req });
  //   if (res.status !== 201) {
  //     throw new Error(res);
  //   }
  //   return res;
  // }

  async reqPostPasteAudioFileAPI(req: { id: string; pwd: string; ip: string; port: string; bsfCd: string; bsfFurl: string }) {
    const res = await apiPost({ path: '/bs/isapi/audiofile', req });
    if (res.status !== 201) {
      throw new Error(res);
    }
    return res;
  }

  async reqConnCheck(param: { ip: string; port: string; id: string; pwd: string }) {
    const res = await apiGet({
      path: '/bs/isapi',
      req: {
        url: `http://${param.ip}:${param.port}/ISAPI/AccessControl/EventCardLinkageCfg/CustomAudio/GetCustomAudioStorageInfo?format=json`,
        method: 'GET',
        id: param.id,
        pwd: param.pwd,
      },
      timeout: 1000,
    });
    if (res.status !== 200) {
      throw new Error('');
    }
    return res?.data.data;
  }
  /* eslint-enable class-methods-use-this */
}
